module.exports = __webpack_public_path__ + "img/h2501.83766966.png";